import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_ENDPOINTS, METHOD_TYPE } from "../../../utils/apiUrls";
import api from "../../../utils/api";

const initialState = {
    searchCompanyList: [],
    compnayAddress: {},
    companyDetails: {},
    corporateBankDetails: [],
    corporateBankDetailById: {},
    getDocuments: [],
    officersList: [],
    kycSuccessDetails:[],
    individualShareholdersList: {rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200},
    individualAllShareholdersList : [],
    shareholderRepresentativeDetails: {rows: [], count: 0, totalPages: 0, currentPage: 1, type: 200},
    isLoading: false,
    error: null,
    corporateClientDetails : {}
};

export const searchCorporateCompany = createAsyncThunk("searchCorporateCompany", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.searchCorporateCompany + queryParam,
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const saveCompanyAddress = createAsyncThunk("saveCompanyAddress", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.saveCompanyAddress,
            data: requestData,
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const updateCompanyAddress = createAsyncThunk("updateCompanyAddress", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.updateCompanyAddress,
            data: requestData,
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const saveCompanyDetailsAndAddress = createAsyncThunk("saveCompanyDetailsAndAddress", async (requestData) => {
    try {
        const payload = requestData?.requestData || requestData;
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.saveCompanyDetailsAndAddress,
            data: payload,
            headers: { ...(requestData?.webformToken && { publictoken: requestData.webformToken, Authorization: '' }) },
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const updateCompanyDetailsAndAddress = createAsyncThunk("updateCompanyDetailsAndAddress", async (requestData) => {
    try {
        const payload = requestData?.requestData || requestData;
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.updateCompanyDetailsAndAddress,
            data: payload,
            headers: { ...(requestData?.webformToken && { publictoken: requestData.webformToken, Authorization: '' }) },
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const saveCorporateInternationalProfile = createAsyncThunk("corporate_onboarding/saveInternationalProfile", async (requestData) => {
    try {
        const payload = requestData?.requestData || requestData;
        const response = await api({
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.saveCorporateInternationalProfile,
            data: payload,
            headers: { ...(requestData?.webformToken && { publictoken: requestData.webformToken, Authorization: '' }) },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});
export const getCompanyAddress = createAsyncThunk("getCompanyAddress", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCompanyAddress + queryParam,
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const getCompanyDetails = createAsyncThunk("getCompanyDetails", async (queryParam) => {
    try {
        const resolvedQuery = queryParam?.queryParam || queryParam;
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCompanyDetails + resolvedQuery,
            headers: { ...(queryParam?.webformToken && { publictoken: queryParam.webformToken, Authorization: '' }) },
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const saveCorporateRegulatoryDocuments = createAsyncThunk("corporate_onboarding/saveRegulatoryDocuments", async (request) => {
    try {
        const payload = request?.requestData || request;
        const response = await api({
            _skipEncryption: true,
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.saveCorporateRegulatoryDocuments,
            data: payload,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const getCorporateRegulatoryDocuments = createAsyncThunk("corporate_onboarding/getRegulatoryDocuments", async (request) => {
    try {
        const queryParam = request?.queryParam || request;
        const response = await api({
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateRegulatoryDocuments + queryParam,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const saveCorporateCompliance = createAsyncThunk("corporate_onboarding/saveCompliance", async (request) => {
    try {
        const payload = request?.requestData || request;
        const response = await api({
            _skipEncryption: true,
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.saveCorporateCompliance,
            data: payload,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const getCorporateCompliance = createAsyncThunk("corporate_onboarding/getCompliance", async (request) => {
    try {
        const queryParam = request?.queryParam || request;
        const response = await api({
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateCompliance + queryParam,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const saveCorporateMlro = createAsyncThunk("corporate_onboarding/saveMlroDetails", async (request) => {
    try {
        const payload = request?.requestData || request;
        const response = await api({
            _skipEncryption: true,
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.saveCorporateMlro,
            data: payload,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const getCorporateMlro = createAsyncThunk("corporate_onboarding/getMlroDetails", async (request) => {
    try {
        const queryParam = request?.queryParam || request;
        const response = await api({
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateMlro + queryParam,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const deleteCorporateMlro = createAsyncThunk("corporate_onboarding/deleteMlroDetails", async (request) => {
    try {
        const requestData = { corporate_client_id: Number(request?.corporateClientId) };
        const response = await api({
            method: METHOD_TYPE.delete,
            url: API_ENDPOINTS.deleteCorporateMlro,
            data: requestData,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

export const getRedFlagCompanyHouseCorporateDetails = createAsyncThunk("getRedFlagCompanyHouseCorporateDetails", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCompanyHouseCorporateDetails + queryParam,
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const saveCorporateDeatils = createAsyncThunk("saveCorporateDeatils", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.saveCorporateDeatils,
            data: requestData,
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const createBankDetails = createAsyncThunk("corporate_onboarding/createBankDetails", async ({ queryParam, requestData, webformToken }) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.createBankDetails + queryParam,
            data: requestData,
            headers: { ...(webformToken && { publictoken: webformToken, Authorization: '' }) },
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const updateBankDetails = createAsyncThunk("corporate_onboarding/updateBankDetails", async ({requestObject,queryParam,webformToken}) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.updateBankDetails+queryParam,
            data: requestObject,
            headers: { ...(webformToken && { publictoken: webformToken, Authorization: '' }) }
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const uploadDocuments = createAsyncThunk("corporate_onboarding/uploadDocuments", async (requestObject) => {
    try {
        const payload = requestObject?.requestData || requestObject;
        let data = {
            _skipEncryption: true,
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.uploadDocuments,
            data: payload,
            headers: { ...(requestObject?.webformToken && { publictoken: requestObject.webformToken, Authorization: '' }) }
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const updateUploadDocuments = createAsyncThunk("corporate_onboarding/updateUploadDocuments", async (requestData) => {
    try {
        const payload = requestData?.requestData || requestData;
        let data = {
            _skipEncryption: true,
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.updateUploadDocuments,
            data: payload,
            headers: { ...(requestData?.webformToken && { publictoken: requestData.webformToken, Authorization: '' }) }
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const fetchCorporateBankDetails = createAsyncThunk("fetchCorporateBankDetails", async (request) => {
    try {
        const queryParam = request?.queryParam || request;
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.fetchCorporateBankDetails + queryParam,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const fetchCorporateBankDetailsById = createAsyncThunk("fetchCorporateBankDetailsById", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.fetchCorporateBankDetailsById + queryParam,
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const fetchCorporateUploadedDocument = createAsyncThunk("fetchCorporateUploadedDocument", async (request) => {
    try {
        const queryParam = request?.queryParam || request;
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.fetchCorporateUploadedDocument + queryParam,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const getCompanyOfficers = createAsyncThunk("getCompanyOfficers", async (request) => {
    try {
        const queryParam = request?.queryParam || request;
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCompanyOfficers + queryParam,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const deleteCompanyOfficers = createAsyncThunk("deleteCompanyOfficers", async (id) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.deleteCompanyOfficers,
            data: id
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const getEntityClientDetailsByOomeroId = createAsyncThunk("getEntityClientDetailsByOomeroId", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getEntityClientDetailsByOomeroId + queryParam,
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const createCorporateWebformLink = createAsyncThunk("createCorporateWebformLink", async (request) => {
    try {
        const payload = typeof request === 'object'
            ? request
            : { corporate_client_id: request };
        const response = await api.post(API_ENDPOINTS.createCorporateWebformLink, payload);
        return response.data;
    } catch (error) {
        throw error?.response?.data || error;
    }
});

export const initializeCorporateWebform = createAsyncThunk("initializeCorporateWebform", async ({ corporateClientId, webformToken }) => {
    try {
        const response = await api({
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.initializeCorporateWebform,
            data: { corporate_client_id: corporateClientId },
            headers: { publictoken: webformToken, Authorization: '' },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data || error;
    }
});

export const getCorporateWebformSummary = createAsyncThunk("getCorporateWebformSummary", async ({ corporateClientId, webformToken }) => {
    try {
        const response = await api({
            method: METHOD_TYPE.get,
            url: `${API_ENDPOINTS.getCorporateWebformSummary}?corporate_client_id=${encodeURIComponent(corporateClientId)}`,
            headers: { publictoken: webformToken, Authorization: '' },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data || error;
    }
});

export const completeCorporateWebform = createAsyncThunk("completeCorporateWebform", async ({ corporateClientId, webformToken }) => {
    try {
        const response = await api({
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.completeCorporateWebform,
            data: { corporate_client_id: corporateClientId },
            headers: { publictoken: webformToken, Authorization: '' },
        });
        return response.data;
    } catch (error) {
        throw error?.response?.data || error;
    }
});

export const verifyEntityClientDetailsOtp = createAsyncThunk("verifyEntityClientDetailsOtp", async (requestData) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.verifyEntityClientDetailsOtp,
            data: requestData,
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const getCorporateIndividualShareholder = createAsyncThunk("getCorporateIndividualShareholder", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateIndividualShareholder + queryParam,
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const saveCompanyShareholderRepresentativeDetails = createAsyncThunk("saveCompanyShareholderRepresentativeDetails", async (request) => {
    try {
      const requestData = request?.requestData || request;
      const data = {
        method: METHOD_TYPE.post,
        url: API_ENDPOINTS.saveCompanyShareholderRepresentativeDetails,
        data: requestData,
        headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) }
      };
  
      const response = await api(data);
      return response.data;
    } catch (error) {
  
      throw error?.response?.data;
    }
  });
  export const getCompanyShareholderRepresentativeDetails = createAsyncThunk("getCompanyShareholderRepresentativeDetails", async (request) => {
    try {
        const queryParam = request?.queryParam || request;
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCompanyShareholderRepresentativeDetails+queryParam,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        };
        const response = await api(data);
        return response.data.data;
    } catch (error) {
          
        throw error?.response?.data;
      }
    });

 export const updateCompanyShareholderRepresentativeDetails = createAsyncThunk("updateCompanyShareholderRepresentativeDetails", async ({requestData,queryParam,webformToken}) => {
            try {
              const data = {
                method: METHOD_TYPE.post,
                url: API_ENDPOINTS.updateCompanyShareholderRepresentativeDetails+queryParam,
                data: requestData,
                headers: { ...(webformToken && { publictoken: webformToken, Authorization: '' }) }
              };
          
              const response = await api(data);
              return response.data;
            } catch (error) {
          
              throw error?.response?.data;
            }
          });
export const fetchAllCorporateIndividualShareholders = createAsyncThunk("fetchAllCorporateIndividualShareholders", async (request) => {
    try {
        const queryParam = request?.queryParam || request;
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.fetchAllCorporateIndividualShareholders + queryParam,
            headers: { ...(request?.webformToken && { publictoken: request.webformToken, Authorization: '' }) },
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});
export const generateCorporateClientOomeroId = createAsyncThunk("generateCorporateClientOomeroId", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.generateCorporateClientOomeroId + queryParam,
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const getCorporateClientDetails = createAsyncThunk("getCorporateClientDetails", async (queryParam) => {
    try {
        let data = {
            method: METHOD_TYPE.get,
            url: API_ENDPOINTS.getCorporateClientDetails + queryParam,
        };
        const response = await api(data);
        return response.data.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const addScreeningComments = createAsyncThunk("corporate_screening/addScreeningComments", async ({ payload }) => {
    try {
        const normalizedPayload = {
            ...payload,
            comment_type: payload?.comment_type || payload?.commentType || 'aml',
            commentType: payload?.commentType || payload?.comment_type || 'aml'
        }

        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.addCorporateScreeningComments,
            data: normalizedPayload
        };
        const response = await api(data);
        return response.data;

    } catch (error) {
        throw error?.response?.data;
    }
});

export const triggerReKycEmail = createAsyncThunk("corporate_screening/triggerReKycEmail", async (queryParams) => {
    try {
        let data = {
            method: METHOD_TYPE.post,
            url: API_ENDPOINTS.triggerReKycEmail + queryParams
        };
        const response = await api(data);
        return response.data;
    } catch (error) {
        throw error?.response?.data;
    }
});

const corporateOnboardingSlice = createSlice({
    name: "corporateOnboarding",
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        const handleLoading = (state, action) => {
            state.isLoading = action.meta.requestStatus === 'pending';
        };

        builder
            .addCase(searchCorporateCompany.fulfilled, (state, action) => {
                state.searchCompanyList = action.payload;
            })
            .addCase(getCorporateClientDetails.fulfilled, (state, action) => {
                state.corporateClientDetails = action.payload;
            })
            .addCase(getCompanyDetails.fulfilled, (state, action) => {
                state.companyDetails = action.payload
            })
            .addCase(getCompanyAddress.fulfilled, (state, action) => {
                state.compnayAddress = action.payload;
            })
            .addCase(fetchCorporateBankDetails.fulfilled, (state, action) => {
                state.corporateBankDetails = action.payload;
            })
            .addCase(fetchCorporateUploadedDocument.fulfilled, (state, action) => {
                state.getDocuments = action.payload;
            })
            .addCase(getCompanyOfficers.fulfilled, (state, action) => {
                state.officersList = action.payload;
            })
            .addCase(getCorporateIndividualShareholder.fulfilled, (state, action) => {
                state.individualShareholdersList = action.payload;
            })
            .addCase(fetchAllCorporateIndividualShareholders.fulfilled, (state, action) => {
                state.individualAllShareholdersList = action.payload;
            })
            .addCase(getCompanyShareholderRepresentativeDetails.fulfilled, (state, action) => {
                state.shareholderRepresentativeDetails = action.payload;
            })
            .addCase(generateCorporateClientOomeroId.fulfilled, (state, action) => {
                state.kycSuccessDetails = action.payload;
            }) 
            .addCase(addScreeningComments.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addCase(fetchCorporateBankDetailsById.fulfilled, (state, action) => {
              state.corporateBankDetailById=action.payload
            })
            .addCase(triggerReKycEmail.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.error = null;
            })
            .addMatcher(
                (action) =>
                    action.type === searchCorporateCompany.pending.type ||
                    action.type === searchCorporateCompany.fulfilled.type ||
                    action.type === searchCorporateCompany.rejected.type ||
                    action.type === saveCompanyAddress.pending.type ||
                    action.type === saveCompanyAddress.rejected.type ||
                    action.type === saveCompanyAddress.fulfilled.type ||
                    action.type === saveCompanyDetailsAndAddress.pending.type ||
                    action.type === saveCompanyDetailsAndAddress.rejected.type ||
                    action.type === saveCompanyDetailsAndAddress.fulfilled.type ||
                    action.type === getCompanyAddress.pending.type ||
                    action.type === getCompanyAddress.rejected.type ||
                    action.type === getCompanyAddress.fulfilled.type ||
                    action.type === getCompanyDetails.pending.type ||
                    action.type === getCompanyDetails.rejected.type ||
                    action.type === getCompanyDetails.fulfilled.type ||
                    action.type === updateCompanyAddress.pending.type ||
                    action.type === updateCompanyAddress.rejected.type ||
                    action.type === updateCompanyAddress.fulfilled.type ||
                    action.type === updateCompanyDetailsAndAddress.pending.type ||
                    action.type === updateCompanyDetailsAndAddress.rejected.type ||
                    action.type === updateCompanyDetailsAndAddress.fulfilled.type ||
                    action.type === saveCorporateDeatils.pending.type ||
                    action.type === saveCorporateDeatils.rejected.type ||
                    action.type === saveCorporateDeatils.fulfilled.type ||
                    action.type === getRedFlagCompanyHouseCorporateDetails.pending.type ||
                    action.type === getRedFlagCompanyHouseCorporateDetails.rejected.type ||
                    action.type === getRedFlagCompanyHouseCorporateDetails.fulfilled.type ||
                    action.type === createBankDetails.pending.type ||
                    action.type === createBankDetails.fulfilled.type ||
                    action.type === createBankDetails.rejected.type ||
                    action.type === updateBankDetails.pending.type ||
                    action.type === updateBankDetails.fulfilled.type ||
                    action.type === updateBankDetails.rejected.type ||
                    action.type === uploadDocuments.pending.type ||
                    action.type === uploadDocuments.fulfilled.type ||
                    action.type === uploadDocuments.rejected.type ||
                    action.type === updateUploadDocuments.pending.type ||
                    action.type === updateUploadDocuments.fulfilled.type ||
                    action.type === updateUploadDocuments.rejected.type ||
                    action.type === fetchCorporateBankDetails.pending.type ||
                    action.type === fetchCorporateBankDetails.fulfilled.type ||
                    action.type === fetchCorporateBankDetails.rejected.type ||
                    action.type === fetchCorporateUploadedDocument.pending.type ||
                    action.type === fetchCorporateUploadedDocument.fulfilled.type ||
                    action.type === fetchCorporateUploadedDocument.rejected.type ||
                    action.type === getCompanyOfficers.pending.type ||
                    action.type === getCompanyOfficers.fulfilled.type ||
                    action.type === getCompanyOfficers.rejected.type ||
                    action.type === deleteCompanyOfficers.pending.type ||
                    action.type === deleteCompanyOfficers.fulfilled.type ||
                    action.type === deleteCompanyOfficers.rejected.type ||
                    action.type === getCorporateIndividualShareholder.pending.type ||
                    action.type === getCorporateIndividualShareholder.fulfilled.type ||
                    action.type === getCorporateIndividualShareholder.rejected.type ||
                    action.type === fetchAllCorporateIndividualShareholders.pending.type ||
                    action.type === fetchAllCorporateIndividualShareholders.fulfilled.type ||
                    action.type === fetchAllCorporateIndividualShareholders.rejected.type||
                    action.type === getCorporateIndividualShareholder.rejected.type||
                    action.type === saveCompanyShareholderRepresentativeDetails.pending.type||
                    action.type === saveCompanyShareholderRepresentativeDetails.fulfilled.type||
                    action.type === saveCompanyShareholderRepresentativeDetails.rejected.type||
                    action.type === getCompanyShareholderRepresentativeDetails.pending.type||
                    action.type === getCompanyShareholderRepresentativeDetails.fulfilled.type||
                    action.type === getCompanyShareholderRepresentativeDetails.rejected.type||
                    action.type === updateCompanyShareholderRepresentativeDetails.pending.type||
                    action.type === updateCompanyShareholderRepresentativeDetails.fulfilled.type||
                    action.type === updateCompanyShareholderRepresentativeDetails.rejected.type ||
                    action.type === getCorporateClientDetails.pending.type ||
                    action.type === getCorporateClientDetails.fulfilled.type ||
                    action.type === getCorporateClientDetails.rejected.type ||
                    action.type === generateCorporateClientOomeroId.pending.type ||
                    action.type === generateCorporateClientOomeroId.fulfilled.type ||
                    action.type === generateCorporateClientOomeroId.rejected.type||
                    action.type === addScreeningComments.pending.type ||
                    action.type === addScreeningComments.fulfilled.type ||
                    action.type === addScreeningComments.rejected.type||
                    action.type === fetchCorporateBankDetailsById.pending.type ||
                    action.type === fetchCorporateBankDetailsById.fulfilled.type ||
                    action.type === fetchCorporateBankDetailsById.rejected.type||
                    action.type === triggerReKycEmail.pending.type ||
                    action.type === triggerReKycEmail.fulfilled.type ||
                    action.type === triggerReKycEmail.rejected.type,
                
                handleLoading
            );
    }

});

export const { } = corporateOnboardingSlice.actions;
export default corporateOnboardingSlice.reducer;
